import { memo } from 'react';
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react';
import { ChevronDown } from 'components/gruenland/icons/ChevronDown';
import { useFormat } from 'helpers/hooks/useFormat';
import SortFacet from '../facets/sort';

const SortFacets: React.FC = () => {
  const { formatMessage } = useFormat({ name: 'gruenland' });

  return (
    <Menu as="div" className="relative">
      <>
        <MenuButton>
          <div className="flex items-center gap-2">
            <span className="text-[14px]">{formatMessage({ id: 'plp.sortBy', defaultMessage: 'Ordina per' })}</span>
            <ChevronDown className="w-5" />
          </div>
        </MenuButton>
        <MenuItems
          modal={false}
          transition
          className="absolute left-0 z-20 min-w-[280px] origin-top-left translate-y-[10px] rounded-md bg-white shadow-lg transition ease-out data-[closed]:scale-95 data-[closed]:opacity-0"
        >
          <MenuItem>
            <SortFacet />
          </MenuItem>
        </MenuItems>
      </>
    </Menu>
  );
};

export default memo(SortFacets);
